import React from 'react';

interface StyleProps {
    onClick: () => void;
    index: number;
    currentIndex: number;
}

const SliderIndicator: React.FC<StyleProps> = props => {
    return (
        <span
            onClick={props.onClick}
            className={
                (props.index === props.currentIndex ? 'border-tan' : 'border-tan-light') +
                ' border-b text-xs inline-block mr-1 w-[35px] lg:hidden'
            }
        >
            {' '}
        </span>
    );
};

export default SliderIndicator;
